<template>
  <main>
    <Transition name="fade">
      <Loader v-if="!$page || !$beet.isReady" />
    </Transition>
    <template v-if="$page && $beet.isReady">
      <Banner :content="$page.header" />
      <PromoSection :content="promoSection" />
      <RoomCardsSection :labels="labels" :rooms="rooms" @open-modal="updateModalImages" />
      <RoomCardsSection
        :labels="labels"
        :rooms="nightlifeRooms"
        :is-dark="true"
        :title-block="nightlifeTitleBlock"
        @open-modal="updateModalImages"
      />
      <QuestionSection />
      <ImagesModal :images="modalImages" />
    </template>
  </main>
</template>

<script>
import ImagesModal from '@/components/blocks/ImagesModal.vue'
import Banner from '@/components/sections/Banner.vue'
import PromoSection from '@/components/sections/PromoSection.vue'
import QuestionSection from '@/components/sections/QuestionSection.vue'
import RoomCardsSection from '@/components/sections/RoomCardsSection.vue'
import Loader from '@/components/small/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin'

export default {
  mixins: [PageMetaMixin],
  name: 'Room',
  components: { Banner, ImagesModal, Loader, PromoSection, QuestionSection, RoomCardsSection },
  beetPage: 'rooms',
  data() {
    return {
      modalImages: [],
    }
  },
  computed: {
    labels() {
      return {
        details: this.$page.more_details_label,
        max: this.$page.max_people_label,
        reserve: this.$page.reserve_label,
      }
    },
    nightlifeRooms() {
      return Object.values(this.$beet.rooms).filter((room) => room.is_nightlife)
    },
    nightlifeTitleBlock() {
      return {
        description: this.$page.nightlife.subtitle,
        subtitle: this.$page.nightlife.title,
        title: this.$page.nightlife.label,
      }
    },
    promoSection() {
      return {
        special: this.$beet.options.discounts.content,
        text: this.$page.description,
      }
    },
    rooms() {
      return Object.values(this.$beet.rooms).filter((room) => !room.is_nightlife)
    },
  },
  methods: {
    updateModalImages(images) {
      this.modalImages = images
    },
  },
}
</script>
